import { BROWSER_MODE } from '../constants';

export const createCanvasRenderingContext2D = () => BROWSER_MODE ? document.createElement('canvas').getContext('2d') as CanvasRenderingContext2D : {} as CanvasRenderingContext2D;
